import React from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import DialogContainer, {DialogButton} from '../AlertDialog/DialogContainer';
import {Colors} from '../../styles/Colors';
import TransactionsContent from './TransactionsContent';

const useStyles = makeStyles(() => ({
    modalContainer: {
        '& .MuiDialogContent-root': {
            background: Colors.SmokeBackground,
            width: 1002,
            padding: '36px 32px',
            overflowX: 'hidden',
        },
    },
    header: {
        '& .MuiTypography-h6': {
            fontWeight: 'bold',
            fontSize: 18,
        },
    },
    primaryActionButton: {
        '& .MuiButton-label': {
            color: Colors.Primary,
        },
    },
    filtersRow: {
        display: 'flex',
        alignItems: 'flex-start',
        paddingBottom: 25,

        '& .MuiFormControl-root': {
            marginRight: 18,
        },

        '& .date-time-picker': {
            '& .MuiInputBase-input': {
                width: 208,
            },
        },
    },
    searchButton: {
        minWidth: 96,
        marginTop: 8,
        '& .MuiButton-label': {
            color: Colors.White,
        },
    },
    table: {
        marginTop: 10,

        '& .MuiTableBody-root .MuiTableCell-root': {
            alignItems: 'center',
        },
    },
}));

export interface AccountTransactionsDialogProps {
    isOpen: boolean;
    toggleVisibility: () => void;
    iAccount: number;
    accountId: string;
}

const TransactionsDialog: React.VFC<AccountTransactionsDialogProps> = ({
    isOpen,
    toggleVisibility,
    iAccount,
    accountId,
}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <DialogContainer
            isOpen={isOpen}
            dataQa="account-transactions-dialog"
            header={t('screens:accounts.transactionsFor', {accountId})}
            headerClass={classes.header}
            className={classes.modalContainer}
            dialogActionsButtons={[
                <DialogButton
                    className={classes.primaryActionButton}
                    key="close"
                    label={t('common:close')}
                    onClick={toggleVisibility}
                />,
            ]}
        >
            <TransactionsContent
                iAccount={iAccount}
                hideActions
                resetKey={isOpen}
                filtersClassName={classes.filtersRow}
                searchButtonClassName={classes.searchButton}
                tableClassName={classes.table}
            />
        </DialogContainer>
    );
};

export default TransactionsDialog;